"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var text_1 = require("../text");
function ProgressBar(props) {
    var now = props.now;
    var percentage = Math.min(100, now);
    var _a = props.label, label = _a === void 0 ? function () { return "".concat(percentage, "% complete"); } : _a;
    return (react_1.default.createElement("div", { style: {
            borderRadius: 24,
            overflow: 'hidden',
            height: 16,
            display: 'flex',
            position: 'relative',
            backgroundColor: '#EFFBF2',
        } },
        react_1.default.createElement("div", { style: {
                width: "".concat(percentage, "%"),
                backgroundColor: '#ABE4BA',
                transition: 'width .2s',
            } }),
        react_1.default.createElement(text_1.Text, { size: "small", color: "#0E5464", style: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#0E5464',
                whiteSpace: 'nowrap',
            } }, label(percentage))));
}
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=index.js.map